import React from "react";
import styled from "styled-components/macro";

const Arrow = ({ side = "left", size = 60 }) => {
  if (side === "up" || side === "down")
    return (
      <ArrowVerticalWrapper height={size}>
        {side === "up" && <PointUp />}
        <VerticalLine height={size} />
        {side === "down" && <PointDown />}
      </ArrowVerticalWrapper>
    );

  return (
    <ArrowWrapper>
      {side === "left" && <PointLeft />}
      <Line />
      {side === "right" && <PointRight />}
    </ArrowWrapper>
  );
};

const ArrowVerticalWrapper = styled.div`
  margin-top: 3px;
  height: ${({ height }) => height}px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const VerticalLine = styled.div`
  height: ${({ height }) => height - 25}px;
  background: #b8b7b7;
  width: 2px;
  float: left;
`;

const ArrowWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;
const Line = styled.div`
  width: 100%;
  border-top: 1px solid dimgray;
  height: 1px;
  float: left;
`;

const PointRight = styled.div`
  width: 0;
  height: 0;
  transform: rotateZ(90deg);
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 11px solid #a1a0a0;
  float: right;
`;

const PointLeft = styled.div`
  width: 0;
  height: 0;
  transform: rotateZ(270deg);
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 11px solid #a1a0a0;
  float: left;
`;

const PointUp = styled.div`
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 11px solid #a1a0a0;
`;

const PointDown = styled.div`
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 11px solid #a1a0a0;
`;

export { Arrow };
